import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import configStore from "store";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import AppThemeProvider from "theme";
import i18n from "./utils/i18LanguageTranslation/i18n";
import "assets/fonts/fonts.scss";
import "assets/styles/global.css";
import "@syncfusion/ej2-react-layouts/styles/material.css";
import AuthProvider from "context/AuthContext";
import { I18nextProvider } from "react-i18next";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import LazyLoading from "components/fallbackUI/LazyLoading";
import FirebaseProvider from "context/FirebaseContext";
import FilterProvider from "context/FilterContext";
import DriveProvider from "context/DriveContext";
const ErrorFallback = lazy(() => import("components/fallbackUI/Error"));
const store = configStore();
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <FirebaseProvider>
      <FilterProvider>
        <I18nextProvider i18n={i18n}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <ErrorBoundary FallbackComponent={ErrorFallback} onError={(error) => {
              const message = error?.message || "";
              const name = error?.name || "";

              const isChunkError =
                name === "ChunkLoadError" ||
                /Loading chunk [\d]+ failed/i.test(message) ||
                /Loading CSS chunk [\d]+ failed/i.test(message) ||
                /ChunkLoadError/i.test(message) ||
                /Failed to fetch dynamically imported module/i.test(message);

              if (!isChunkError) {
                return;
              }

              const reloadKey = "bigfoot_chunk_reload_attempted";

              if (sessionStorage.getItem(reloadKey) === "1") {
                return;
              }

              sessionStorage.setItem(reloadKey, "1");

              window.location.reload();
            }}>
              <Router>
                <Suspense fallback={<LazyLoading />}>
                  <Provider store={store}>
                    <AppThemeProvider>
                      <AuthProvider>
                        <DriveProvider>
                          <App />
                        </DriveProvider>
                      </AuthProvider>
                    </AppThemeProvider>
                  </Provider>
                </Suspense>
              </Router>
            </ErrorBoundary>
          </LocalizationProvider>
        </I18nextProvider>
      </FilterProvider>
    </FirebaseProvider>
  </React.StrictMode>,
);

reportWebVitals();
